import { render, staticRenderFns } from "./PracticeQuestion.vue?vue&type=template&id=287e7c88&scoped=true&lang=pug&"
import script from "./PracticeQuestion.vue?vue&type=script&lang=ts&"
export * from "./PracticeQuestion.vue?vue&type=script&lang=ts&"
import style0 from "./PracticeQuestion.vue?vue&type=style&index=0&id=287e7c88&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "287e7c88",
  null
  
)

export default component.exports